import React, { useState, useEffect } from 'react';
import { fetchWithAuth } from '../../utils/api';
import { formatNumber, formatWeight } from '../../utils/helpers';
import { Users, X } from 'lucide-react';

function ViewHarvestAgentsModal({ tally, onClose, onShowInPage, user, handleLogout }) {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!tally) return;

    setLoading(true);
    fetchWithAuth('/harvest_agents', {}, user, handleLogout)
      .then(res => res.json())
      .then(data => {
        const filtered = (data || []).filter(a => a.sale_tally === tally);
        setAgents(filtered);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setError('Failed to fetch harvest agents');
        setLoading(false);
      });
  }, [tally, user, handleLogout]);

  if (!tally) return null;

  return (
    <div className="modal" onClick={onClose}>
      <div className="modal-content wide" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title-group">
            <Users size={24} />
            <h3>Harvest Agents <span className="highlight" style={{marginLeft: '0.5rem'}}>#{tally}</span></h3>
          </div>
          <button className="close-btn" onClick={onClose}><X size={20} /></button>
        </div>

        {loading ? (
          <div className="text-center" style={{ padding: '4rem', color: 'var(--text-secondary)' }}>Loading agents...</div>
        ) : error ? (
          <div className="status-error text-center" style={{ padding: '4rem' }}>{error}</div>
        ) : agents.length === 0 ? (
          <div className="text-center" style={{ padding: '4rem', color: 'var(--text-secondary)' }}>No harvest agents found for this tally sheet.</div>
        ) : (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Employee</th>
                  <th>Buyer</th>
                  <th className="text-right">Heads</th>
                  <th className="text-right">Weight (kg)</th>
                </tr>
              </thead>
              <tbody>
                {agents.map(agent => (
                  <tr key={agent.id}>
                    <td>{new Date(agent.date).toLocaleDateString()}</td>
                    <td><strong>{agent.employee_name}</strong></td>
                    <td>{agent.buyer}</td>
                    <td className="text-right">{formatNumber(agent.heads)}</td>
                    <td className="text-right">{formatWeight(agent.kilos)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="totals-row">
                  <td colSpan="3">Totals</td>
                  <td className="text-right status-paid">{formatNumber(agents.reduce((sum, a) => sum + a.heads, 0))}</td>
                  <td className="text-right highlight">{formatWeight(agents.reduce((sum, a) => sum + a.kilos, 0))}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}

        <div className="form-actions">
          <button onClick={() => onShowInPage(tally)} className="action-btn">Show in Harvest Agents Page</button>
          <button onClick={onClose} className="secondary-btn">Close</button>
        </div>
      </div>
    </div>
  );
}

export default ViewHarvestAgentsModal;
